<script>
import api from './../apiBridge'

const EXCLUSION_LIST = [
  'done',
  'no thank-you',
  'add',
//  'agg chk#',
//  'check #',
  '. check #',
];

export default {
  name : 'orderitems',

  props: {
    passedItemList: {
      type: Array,
      default: null
    },
    orderId: {
      type: Number,
      default: 0
    },
    customerName: {
      type: String,
      default: ''
    },
    inGFB: {
      type: Boolean,
      default: false
    }
  },

  methods: {

    clearOrderItems() {
      this.itemList = [];
      this.$forceUpdate();  
    },

    setHidden(flag) {
      if (flag === true) {
        this.visibility = 'hidden';
      } else {
        this.visibility = 'visible';
      }
    },

    overrideOrderItems(savedOrder) {
      console.log('Overriden Items loaded:'  + savedOrder.orderId);
      this.itemList = [];
      this.visibility = 'hidden';
      this.postPay = false;
      this.$forceUpdate();

      this.$nextTick(() => {
        this.itemList = savedOrder.items;
        this.orderTicket = savedOrder.orderTicket;
        this.postPay = savedOrder.postPay;

        this.$forceUpdate();
        setTimeout(() =>{
          this.updateOrder();
          setTimeout(()=>{
            this.visibility = 'visible';
          }, 220);          
        },100);
      });

    },

    getOrderItems(orderId) {
      if (!orderId) orderId = this.orderId; 
      if (!orderId) return;

      console.log('Getting items for order: ' + orderId);
      this.visibility = 'hidden';

      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getECommItems'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;

      api.httpGet(apiParameters, function (response) {
        self.itemListRaw = response.data;
        self.processItems(self.itemListRaw);
      });
    },

    processItems(items) {
      this.visibility = 'hidden';
      this.postPay = false;

      // hide orders that have no items, request parent to hide
      if (!items || !items.length) {
          this.$emit('hideOrder', {
            orderId: this.orderId,
          });
          return;
      }

      var rootItems = [];
      var subProducts = [];
      var subItems = [];

/*
      for (var i=0; i<items.length; i++) {
        if (!this.inGFB && items[i].item.dtl_name
            && items[i].item.dtl_name.substring(0,1) == '*') {
          // use naming convention of * as first char to signify prefix as well
          // in that case remove the * and set Prefix flag
          items[i].item.dtl_name = items[i].item.dtl_name.substring(1);
          items[i].item.Prefix = 'T';
        }
      }
*/

      // join prefix items name to next product item name
      for (var i=0; i<items.length; i++) {
        if ((items[i].item.Prefix == 'T' || items[i].item.dtl_name == 'Agg Chk#') && items[i+1]) {
          if (EXCLUSION_LIST.indexOf((''+items[i].item.dtl_name).toLowerCase()) >= 0) {
            // ignore
          } else {
            if (items[i+1].item.ref) {
              // special case for Agg Chk# reference, use ref field
              items[i+1].item.dtl_name = (''+items[i+1].item.ref).trim();
              items[i+1].item.isCheckHeader = true;

              if (items[i-1]) {
                items[i-1].item.isCheckHeader = true;
              }
            } else if (EXCLUSION_LIST.indexOf((''+items[i+1].item.dtl_name).toLowerCase()) >= 0) {
              items[i+1].item.dtl_name = items[i].item.dtl_name;
            } else {
              items[i+1].item.dtl_name = items[i].item.dtl_name + ' ' + items[i+1].item.dtl_name;
            }

            this.refId = items[i+1].item.dtl_name;
          }
        }

        if (items[i].item.ref) {
          let ref = (''+items[i].item.ref).trim();
          
          if (ref.indexOf('POST PAY') >= 0
              || ref.indexOf('PAY@REST') >= 0 
              || ref.indexOf('CASH') >= 0) {

            if (api.brand != 'harveys') {
              this.postPay = true;
            }
          } else if (ref.indexOf('CANCELLED') >= 0) {
            // hide voided orders
            this.voided = true;
          } else if (items[i].item.dtl_name == 'GUEST NAME') {
            items[i].item.isCheckHeader = true;
            items[i].item.dtl_name = this.$t('name') + ': ' + ref;
            this.refId = ref;
          }
        }
      }

      for (var i=0; i<items.length; i++) {
        // collapse down to simplify
        items[i] = items[i].item;

        // check for order ticket id via convention
        if (items[i].mi_obj_num == 1134 && items[i].ref.indexOf(' ') == 8) {
          this.orderTicket =  items[i].ref.replace(' ','');
        }


        if (!items[i].dtl_name
            || items[i].Prefix=='T' 
            || EXCLUSION_LIST.indexOf((''+items[i].dtl_name).toLowerCase()) >= 0) {
          // ignore
        } else {
          if (items[i].parent_dtl_seq || items[i].combo_grp_seq) {
            if (items[i].parent_dtl_seq) {
              // push to sub-items and remove from main
              subItems.push(items[i]);
            } else {
              // push to sub-products and remove from main
              items[i].items = [];
              subProducts.push(items[i]);
            }
          } else if (items[i].dtl_name) {
            // create a sub-items array on main items
            items[i].items = [];

            // add this item to root list
            rootItems.push(items[i])

            // add a marker to subProducts to signify a break
            subProducts.push('break');
          }

        }
      }

      // add sub-items/products back in proper hiearchy
      if (subItems.length) {
        for (var s=0; s<subItems.length; s++) {
          // add sub-items to main-products
          for (var m=0; m<rootItems.length; m++) {
            if (subItems[s].parent_dtl_seq == rootItems[m].dtl_seq) {
              rootItems[m].items.push(subItems[s]);
            }
          }

          // also add sub-items to sub-products
          for (var p=0; p<subProducts.length; p++) {
            if (subItems[s].parent_dtl_seq == subProducts[p].dtl_seq
                && subItems[s].combo_grp_seq == subProducts[p].combo_grp_seq
                && subItems[s].dtl_id > subProducts[p].dtl_id) {
              subProducts[p].items.push(subItems[s]);
            }
          }
        }
      }

      // add sub-products to main items
      if (subProducts.length) {
        var m = -1        
        for (var s=0; s<subProducts.length; s++) {
          if (subProducts[s] == 'break') {
            m++;
          } else if (rootItems[m] && rootItems[m].items) {
            rootItems[m].items.push(subProducts[s]);
          }
        }
      }

      if (this.groupLikeItems) {
        // remove combos (print_grp=97 or 15) and collapse their items to root
        var collapsedRootItems = [];
        for (var i=0; i<rootItems.length; i++) {
          if (rootItems[i].items && rootItems[i].items.length) {
            if ([15, 97].indexOf(rootItems[i].print_grp) >= 0) {
              for (var s=0; s<rootItems[i].items.length; s++) {
                rootItems[i].items[s].levels = 2;
                collapsedRootItems.push(rootItems[i].items[s]);
              }
            } else {
              rootItems[i].levels = 2;
              collapsedRootItems.push(rootItems[i]);
            }
          } else {
            rootItems[i].levels = 1;
            collapsedRootItems.push(rootItems[i]);            
          }
          
          if (rootItems[i].dtl_name ==  'Agg Chk#') {
            rootItems[i].isCheckHeader = true;
            if (rootItems[i].levels == 1) {
              rootItems[i].hidden = true;
            }
          }
        }

        // sort main items by print_grp
        collapsedRootItems.sort(function(a,b) {
                      if (b.isCheckHeader) // header sorted to top
                        return 1;
                      if (a.print_grp < b.print_grp)
                          return 1;
                      if (a.print_grp > b.print_grp)
                          return -1;
                      if (a.dtl_name > b.dtl_name) 
                          return 1;
                      if (a.dtl_name < b.dtl_name) 
                          return -1;

                      return 0;
                  });

        this.itemList = collapsedRootItems;    
      } else {
        // show ordered by combo
        for (var i=0; i<rootItems.length; i++) {
          var levels = 1;
          if (rootItems[i].items && rootItems[i].items.length) {
            levels = 2;
            for (var s=0; s<rootItems[i].items.length; s++) {
              if (rootItems[i].items[s].items && rootItems[i].items[s].items.length) {
                // for each sub-item, sort sub-sub-items by print_grp
                rootItems[i].items[s].items.sort(function(a,b) {
                            if (a.print_grp > b.print_grp)
                                return 1;
                            if (a.print_grp < b.print_grp)
                                return -1;
                            return 0;
                        });
                                        
                levels = 3;
                break;
              }
            }
          }
          rootItems[i].levels = levels;
          
          if (rootItems[i].dtl_name ==  'Agg Chk#') {
            rootItems[i].isCheckHeader = true;
            if (rootItems[i].levels == 1) {
              rootItems[i].hidden = true;
            }
          }
        }
        this.itemList = rootItems;
      }

      // for each item, sort sub-items by print_grp
      for (var i=0; i<this.itemList.length; i++) {
        if (this.itemList[i].items && this.itemList[i].items.length) {
          this.itemList[i].items.sort(function(a,b) {
                        if (a.print_grp > b.print_grp)
                            return 1;
                        if (a.print_grp < b.print_grp)
                            return -1;
                        return 0;
                    });
          }
      }




      this.$forceUpdate();

      this.$nextTick(()=>{
        this.updateOrder(true);
      });
    },

    updateOrder(updateHash) {
        this.visibility = 'hidden';
        if (this.$refs.listContainer) {
          this.$emit('updateOrder', {
            orderId: this.orderId,
            orderTicket: this.orderTicket || null,
            refId: this.refId || null,
            postPay: this.postPay || false,
            voided: this.voided || false,
            processedItems: this.itemList,
            listContainer: this.$refs.listContainer,
            updateHash: updateHash || false
          });
        }
        setTimeout(()=>{
          this.visibility = 'visible';
        }, 220);
    },
    
    checkItemDisplay(item) {
      if (item.hidden) {
        return false;
      }

      return true;
    },

    calcFontSize(item) {
      if (item.levels < 3 && !item.isCheckHeader) {
        return 'font-size: small;';
      }
      return '';
    },

    checkHeader(item){
      if (item.isCheckHeader) {
        return 'border: solid green 1px; padding: 5px 15px;';
      }
      return '';
    },

    init() {
      if (this.passedItemList && this.passedItemList.length) {
        this.itemListRaw = this.passedItemList;
        this.processItems(this.itemListRaw);
      } else if (this.orderId) {
//        this.getOrderItems(this.orderId)
      }

    }

  },


  mounted: function() {
    console.log('order items');

    this.init();
  },

  data() {
    return {
      groupLikeItems: true, // behaviour flag, may make ui switch in future
      itemListRaw: [],
      itemList: [],
      visibility: 'visible',
      refId: '',
      postPay: false,
      language: api.language,
      error: ''
    }
  },

}
</script>


<template>
  <ul ref="listContainer" class="list-container" :style="'visibility:' + visibility"
  >
    <div v-if="customerName" 
     style="margin: 0px 40px 10px 0px; border: solid green 1px; padding: 5px 15px;"
    >
      {{$t('name')}}:<br>{{'&nbsp;' + customerName}}
    </div>
    <span v-for="(item, index) in itemList" class="orderItem">
      <li v-if="checkItemDisplay(item)">
        <div :style="'margin: 0px 40px 10px 0px;'  + checkHeader(item)">
          <span v-if="item.chk_cnt && item.chk_cnt > 1">{{item.chk_cnt}} -</span>
          <span v-if="language=='FR'" >{{item.name_2 || item.dtl_name}}</span>
          <span v-else >{{item.dtl_name}}</span>
          <div v-if="item.items">
            <ul :style="'list-style-type: none; margin: 0px 20px 0px -25px;' + calcFontSize(item)">
              <li v-for="subItem, index in item.items">
                <div v-if="checkItemDisplay(subItem)">
                  <span v-if="language=='FR'" >{{subItem.name_2 || subItem.dtl_name}} <span v-if="subItem.qty && subItem.qty>1"> (x{{subItem.qty}})</span></span> 
                  <span v-else >{{subItem.dtl_name}} <span v-if="subItem.qty && subItem.qty>1"> (x{{subItem.qty}})</span></span> 
                  <br>
                  <div v-if="subItem.items">
                    <ul style="list-style-type: none; margin-left: -25px; font-size: small;">
                      <li v-for="subsubItem in subItem.items">
                        <div v-if="checkItemDisplay(subsubItem)">
                          <span v-if="language=='FR'" >{{subsubItem.name_2 || subsubItem.dtl_name}}</span> 
                          <span v-else >{{subsubItem.dtl_name}}</span> 
                          <br>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </span>
  </ul>
</template>

<style scoped>

.list-container {
  display: flex;
  flex-flow: column wrap;
  list-style-type: none;
  align-content: flex-start;                
  font-size: 16px;
  font-weight: bold;
  height: 100%;
  width: fit-content;
  margin-left: -30px;
  max-width: 16em;
}

</style>


// WEBPACK FOOTER //
// OrderItems.vue?4d5e6ffd